// extracted by mini-css-extract-plugin
export var modal_base = "modal-module--modal_base--bb38c";
export var modal_overlay = "modal-module--modal_overlay--30089";